// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"DocListSimple_placeholder__2owEL"};